import React from 'react'
import './Loader.css'
const Loader = ({rows}:any) => {
    const rowsPerPage = rows.length;
  return (
    <div className="d-flex justify-content-center ">
    <div>
      <div className="table-loading-overlay">
        {/* <div className="newtons-cradle">
          <div className="newtons-cradle__dot"></div>
          <div className="newtons-cradle__dot"></div>
          <div className="newtons-cradle__dot"></div>
          <div className="newtons-cradle__dot"></div>
        </div> */}
       
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50" style={{ zIndex: "999" }} >
            <div className="overlay-loader">
              <div className="loader-container">
                <div className="spinner"></div>
                <div className="loader-text">Loading Data....</div>
              </div>
            </div>
          </div>
      </div>
    </div>
    </div>
  )
}

export default Loader
